var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.606,
    height: 16.207,
    viewBox: "0 0 14.606 16.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M15.084,16.207H2.913A1.887,1.887,0,0,1,1,14.35V1.857A1.887,1.887,0,0,1,2.913,0H13.693a.514.514,0,0,1,.522.506V2.7h.869a.514.514,0,0,1,.522.506V15.7A.514.514,0,0,1,15.084,16.207ZM2.043,3.511V14.35a.858.858,0,0,0,.869.844h11.65V3.714H2.913a1.94,1.94,0,0,1-.869-.2Zm.869-2.5a.858.858,0,0,0-.869.844.858.858,0,0,0,.869.844H13.172V1.013Z",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M7.25,15.083a.5.5,0,0,1-.32-.116l-2-1.667a.5.5,0,0,1,0-.768l2-1.667a.5.5,0,1,1,.641.768L6.031,12.917,7.571,14.2a.5.5,0,0,1-.321.884Z",
    transform: "translate(-1.112 -3.456)",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M14.25,15.083a.5.5,0,0,1-.32-.884l1.539-1.283-1.539-1.283a.5.5,0,1,1,.641-.768l2,1.667a.5.5,0,0,1,0,.768l-2,1.667A.5.5,0,0,1,14.25,15.083Z",
    transform: "translate(-3.782 -3.456)",
    fill: "#94c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M10.25,15.417a.5.5,0,0,1-.137-.019.5.5,0,0,1-.343-.618L11.1,10.113a.5.5,0,0,1,.961.275l-1.333,4.667a.5.5,0,0,1-.481.363Z",
    transform: "translate(-2.614 -3.119)",
    fill: "#94c0d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e3dace75aa5ecdbdb9e4ecf2eb847814.svg";
export { ForwardRef as ReactComponent };